export default __webpack_public_path__ + "static/thumb-19-d0a7c5265cf9844a89f1e1f15e086f5e.jpg";